import {
  AvailableLoginMethodsConfig,
  GetAvailableLoginMethodConfigParameter,
} from '@shopee-user/business-customization-types';

export function getAvailableLoginMethodConfig(
  _: GetAvailableLoginMethodConfigParameter
): AvailableLoginMethodsConfig {
  return [];
}
